import React from "react";

export default function SQL_SET() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_SET</h1>
      <p>This is the SQL_SET component generated from the SQL JSON.</p>
    </div>
  );
}
